import api from '@functions/api'

import type { ContactsInvoiceSummaryModel } from '@models/contactsInvoiceSummary'
import type { AppDispatch } from '@redux/store'
import type { Action, ActionResult, EntityOptions, Errors } from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/contactsInvoiceSummary/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/contactsInvoiceSummary/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/contactsInvoiceSummary/FETCH_FAILURE'

export type ContactsInvoiceSummaryModuleState = {
  errors: string[],
  loaded: boolean,
  loading: boolean,
  result: ContactsInvoiceSummaryModel[],
}

const initialState: ContactsInvoiceSummaryModuleState = {
  errors: [],
  loaded: false,
  loading: false,
  result: [],
}

// Actions
export function fetchRequest(): Action {
  return {
    type: FETCH_REQUEST,
  }
}

type FetchRequestPayload = {
  result: ContactsInvoiceSummaryModel[],
  type: string,
}

export function fetchSuccess(payload: FetchRequestPayload): Action {
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors: Errors = []): Action {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function fetchContactsInvoiceSummary(options: EntityOptions = {}){
  return (dispatch: AppDispatch): Promise<ActionResult<ContactsInvoiceSummaryModel[]>> => {
    dispatch(fetchRequest())

    const promise = api('/contacts/invoices-summary', options)
      .then(({ data }) => {
        dispatch(fetchSuccess({ result: data }))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: ContactsInvoiceSummaryModuleState = initialState,
  action: Action = { type: '' },
): ContactsInvoiceSummaryModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: action.result || state.result,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors: action.errors || [],
        loaded: false,
        loading: false,
      }
    default:
      return state
  }
}
